export default __webpack_public_path__ + "static/media/Why-Worry.72f61260.gif";